$(document).ready(()=>{

//=============================Mobile Navbar================================
	var mobileNavClick = true;
	


	$('#MobileNavTrigger').click(()=>{
		if(mobileNavClick) {
			$('#MobileNav').css("display","block");
			mobileNavClick=false;
		}else{
			$('#MobileNav').css("display","none");
			mobileNavClick=true;
		}
	});
	

//=============================ContactUs Page===============================

	$('#showMap').click(()=>{
		$("#contact-map").css({
			"display":"block"
		});
	});


});